import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurybushireinpune() {



const cardData =
{
  keyword: 'Luxury Bus Hire in Pune',
  heading: 'Sanavi Travels: Luxury Bus Hire in Pune',
  headingDescription: 'Sanavi Travels offers premium luxury bus hire services in Pune, designed for clients who seek superior comfort, elegant interiors, professional service, and smooth group transportation for corporate events, weddings, family trips, picnics, and outstation journeys.',

  top: 'Top Experiences with Luxury Bus Hire in Pune',

  topPlaces: [
    {
      title: 'Luxury Travel for Corporate Events',
      description: 'Luxury bus hire in Pune is an excellent choice for corporate events where comfort, presentation, and punctuality matter. Executives, employees, and guests can travel together in a refined environment featuring push-back seating, air conditioning, spacious legroom, and smooth suspension. Group travel in a luxury bus eliminates coordination issues, ensures on-time arrivals, and reflects a company’s professional image. The calm and comfortable atmosphere allows passengers to relax, network, or prepare for meetings during transit, making the journey productive as well as pleasant.'
    },
    {
      title: 'Wedding Guest Transportation',
      description: 'For weddings and large celebrations, luxury buses provide a stylish and organized way to transport guests. Instead of managing multiple vehicles, families can ensure all guests arrive together comfortably and on schedule. Plush interiors, clean upholstery, and air-conditioned comfort enhance the overall wedding experience. Luxury bus travel reduces stress for hosts while offering guests a premium journey that matches the grandeur of the occasion.'
    },
    {
      title: 'Family & Group Outings',
      description: 'Luxury buses are ideal for family trips, group outings, and special celebrations. Spacious seating, smooth rides, and ample luggage space make long journeys enjoyable for all age groups. Traveling together strengthens bonding, allows shared experiences, and removes the fatigue associated with cramped or multiple vehicles. Families appreciate the safety, comfort, and convenience of a single, high-quality transport solution.'
    },
    {
      title: 'Corporate Picnics & Team Outings',
      description: 'For corporate picnics and team outings around Pune or nearby destinations, luxury buses ensure employees start their leisure experience from the moment the journey begins. Comfortable interiors, organized seating, and professional drivers allow teams to relax, interact, and enjoy the trip without worrying about travel logistics. This enhances morale and makes outings more memorable.'
    },
    {
      title: 'Outstation Luxury Travel',
      description: 'Luxury bus hire is well-suited for outstation travel from Pune to hill stations, pilgrimage destinations, and tourist spots. Designed for long-distance comfort, these buses minimize travel fatigue and provide a smooth, stable ride even on highways and ghat roads. Passengers arrive refreshed and ready to enjoy their destination.'
    },
    {
      title: 'Premium Group Sightseeing',
      description: 'Luxury buses are perfect for sightseeing tours where comfort and visibility are important. Large windows, elevated seating, and climate control enhance the sightseeing experience, making city tours and destination exploration more enjoyable.'
    },
    {
      title: 'VIP & Guest Transportation',
      description: 'For transporting VIPs, dignitaries, or special guests, luxury buses offer a refined and secure travel option. Professional drivers, disciplined schedules, and premium interiors ensure guests feel valued and well cared for.'
    },
    {
      title: 'Stress-Free Event Logistics',
      description: 'Managing transportation for large events can be challenging. Luxury bus hire simplifies logistics by consolidating group travel into a single, well-managed vehicle, reducing delays, confusion, and parking issues.'
    },
    {
      title: 'Comfort Across All Seasons',
      description: 'With air-conditioning, insulated interiors, and smooth suspension, luxury buses provide year-round comfort, whether traveling during Pune’s summer heat or monsoon season.'
    },
    {
      title: 'Cost-Effective Premium Travel',
      description: 'Despite offering premium features, hiring a luxury bus is often more cost-effective than arranging multiple luxury cars. It optimizes fuel costs, tolls, and coordination efforts while delivering a superior group travel experience.'
    }
  ],

  services: [
    {
      name: 'Luxury Bus Hire in Pune',
      description: 'Sanavi Travels provides luxury bus hire services in Pune for clients seeking premium group transportation. These buses feature elegant interiors, push-back seating, air-conditioning, and smooth suspension, making them ideal for corporate events, weddings, family trips, picnics, and outstation travel. With professional drivers and well-maintained vehicles, luxury bus hire ensures a refined, safe, and comfortable journey for all passengers.'
    },
    {
      name: 'AC Luxury Bus Pune',
      description: 'AC luxury buses offer a climate-controlled environment that keeps passengers relaxed and comfortable, especially during long journeys or warm weather conditions.'
    },
    {
      name: 'Non AC Luxury Bus Hire Pune',
      description: 'Non-AC luxury buses provide a balance between comfort and affordability, maintaining spacious seating and smooth rides for group travel.'
    },
    {
      name: '32 Seater Luxury Bus Pune',
      description: '32 seater luxury buses are ideal for medium-sized groups, offering premium comfort and easy maneuverability for city and highway travel.'
    },
    {
      name: '35 Seater Luxury Bus Hire Pune',
      description: '35 seater luxury buses accommodate larger groups comfortably, making them suitable for big events, weddings, and corporate gatherings.'
    },
    {
      name: 'Mini Bus on Rent Luxury Pune',
      description: 'Luxury mini buses are perfect for smaller groups, management teams, and family outings requiring premium comfort in a compact vehicle.'
    },
    {
      name: 'Luxury Bus for Family Pune',
      description: 'Family trips become more enjoyable with luxury bus travel, offering comfort, safety, and ample space for all age groups.'
    },
    {
      name: 'Luxury Bus for Corporate Pune',
      description: 'Corporate clients benefit from punctual service, professional presentation, and a premium travel environment for employees and guests.'
    },
    {
      name: 'Luxury Bus for Group Pune',
      description: 'Group travel in a luxury bus ensures everyone travels together comfortably, improving coordination and shared experiences.'
    },
    {
      name: 'Affordable Luxury Bus Rental Pune',
      description: 'Affordable luxury rental plans allow clients to enjoy premium travel without exceeding budget constraints.'
    },
    {
      name: 'Best Luxury Bus Service Pune',
      description: 'Sanavi Travels is recognized for high service standards, clean vehicles, and reliable luxury bus operations.'
    },
    {
      name: 'Luxury Bus with Driver Pune',
      description: 'Experienced drivers ensure safe navigation, punctual arrivals, and smooth journeys throughout Pune and beyond.'
    },
    {
      name: 'Luxury Bus for Wedding Pune',
      description: 'Ideal for transporting wedding guests in style and comfort, ensuring timely and coordinated arrivals.'
    },
    {
      name: 'Luxury Bus for Picnic Pune',
      description: 'Perfect for leisure outings and picnics, offering a relaxed and enjoyable group travel experience.'
    },
    {
      name: 'Outstation Luxury Bus Pune',
      description: 'Reliable outstation luxury bus services support long-distance travel with enhanced comfort and safety.'
    }
  ],

  tableData: [
    ['AC Luxury Bus', 'Non AC Luxury Bus'],
    ['32 Seater', '35 Seater'],
    ['Corporate Events', 'Wedding Travel'],
    ['Family Trips', 'Group Tours'],
    ['Professional Drivers', 'Premium Interiors']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Premium Travel Experience',
      WhyChoosedescription: 'Luxury buses are designed to deliver superior comfort, elegant interiors, and smooth rides that elevate the overall travel experience.'
    },
    {
      WhyChooseheading: 'Professional & Reliable Service',
      WhyChoosedescription: 'Sanavi Travels ensures punctuality, disciplined operations, and professional conduct for every luxury bus booking.'
    },
    {
      WhyChooseheading: 'Comfort-Focused Fleet',
      WhyChoosedescription: 'Well-maintained buses with push-back seating and climate control ensure passenger comfort on all journeys.'
    },
    {
      WhyChooseheading: 'Experienced Drivers',
      WhyChoosedescription: 'Licensed and experienced drivers handle city, highway, and outstation routes with safety and confidence.'
    },
    {
      WhyChooseheading: 'Transparent Pricing',
      WhyChoosedescription: 'Clear pricing structures help clients plan premium travel without unexpected costs.'
    },
    {
      WhyChooseheading: 'Flexible Rental Options',
      WhyChoosedescription: 'Customizable rental plans cater to different event durations and travel needs.'
    },
    {
      WhyChooseheading: 'Ideal for All Occasions',
      WhyChoosedescription: 'Suitable for corporate events, weddings, family trips, picnics, and sightseeing tours.'
    },
    {
      WhyChooseheading: '24/7 Customer Support',
      WhyChoosedescription: 'Dedicated support ensures smooth coordination before, during, and after the journey.'
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide luxury bus hire services in Pune?',
    answer: 'Yes, Sanavi Travels offers luxury bus hire services in Pune for corporate events, weddings, family trips, picnics, and outstation travel.'
  },
  {
    question: 'Are AC luxury buses available?',
    answer: 'Yes, both AC and Non-AC luxury bus options are available.'
  },
  {
    question: 'Is luxury bus hire suitable for weddings?',
    answer: 'Absolutely. Luxury buses are ideal for transporting wedding guests comfortably and stylishly.'
  },
  {
    question: 'Can luxury buses be hired for corporate events?',
    answer: 'Yes, luxury buses are widely used for corporate meetings, conferences, and team outings.'
  },
  {
    question: 'Do you provide outstation luxury bus services?',
    answer: 'Yes, we offer reliable outstation luxury bus services from Pune.'
  },
  {
    question: 'Are drivers experienced?',
    answer: 'Yes, all drivers are licensed, trained, and experienced in handling luxury group travel.'
  },
  {
    question: 'Is the pricing transparent?',
    answer: 'Yes, our pricing is clear and includes all essential costs without hidden charges.'
  },
  {
    question: 'Can routes and schedules be customized?',
    answer: 'Yes, routes, pickup points, and schedules can be customized as per client requirements.'
  },
  {
    question: 'Are luxury buses maintained regularly?',
    answer: 'Yes, all luxury buses undergo regular maintenance, cleaning, and safety checks.'
  },
  {
    question: 'Is customer support available?',
    answer: 'Yes, 24/7 customer support is available for all bookings.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Mehta',
    feedback: 'We hired a luxury bus from Sanavi Travels for a corporate event in Pune. The bus was extremely comfortable, the interiors were premium, and the service was very professional. It truly enhanced our event experience.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Kavita Shah',
    feedback: 'Sanavi Travels provided a luxury bus for our family wedding guests. Everyone enjoyed the smooth ride and comfortable seating. The service was punctual and well-managed.',
    rating: 5
  }
];










































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Bus Hire in Pune - Sanavi Travels",
  "description": "Sanavi Travels offers luxury bus rental services in Pune. Choose AC, Non AC, 32 seater, 35 seater, or mini luxury buses for family trips, corporate travel, group outings, weddings, picnics, and outstation journeys with professional drivers.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300+"
  }
};









  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Luxury Bus Hire in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire luxury buses in Pune with Sanavi Travels. AC, Non AC, 32 seater, 35 seater, and mini luxury buses available for family trips, corporate travel, group outings, weddings, picnics, and outstation journeys with professional driver at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/311.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurybushireinpune;